import combineReducers from '../lib/combineReducers'

import sites from './sites'
import header from './header'
// import { INIT_REDUCERS } from '../constants'

const reducers = () => {
  const [reducersCombined, initialStateCombined] = combineReducers({
    sites: [sites, sites()],
    header: [header, header()],
  })
  return {
    reducer: reducersCombined,
    initialState: initialStateCombined,
  }
}

export default reducers
